import { Outlet, Route } from "react-router-dom";
import { ROUTES } from "../constants/routes/index";
import CollaboratorFactsheet from "../pages/CollaboratorFactsheet";
import { Flex } from "@fluentui/react-northstar";
import { BREADCRUMB_HUMBERGER_GLOBAL } from "../constants/routes/drawer";
import CustomBreadCrumb from "../components/breadcrumb";
import withAuth from "../HOC/withAuth";

const LayoutFactsheet = withAuth(() => {
    return (
        <Flex
            column
            styles={{ backgroundColor: "#f0f0f0", minHeight: "100vh" }}
        >
            <CustomBreadCrumb
                humberger={BREADCRUMB_HUMBERGER_GLOBAL}
                navList={[
                    {
                        href: ROUTES.home,
                        label: "Accueil",
                    },
                    {
                        href: "#",
                        label: "Ma fiche d'engagement",
                    },
                ]}
            />
            <Outlet />
        </Flex>
    );
});

export const collaboratorFactsheetRoutes = (
    <Route
        path={ROUTES.collaborator_factsheet}
        element={<LayoutFactsheet />}
        key="collaborator_factsheet_outlet"
    >
        <Route
            index
            path={""}
            element={<CollaboratorFactsheet />}
            key="collaborator_factsheet"
        />
    </Route>
);

export default collaboratorFactsheetRoutes;
